import { cookiesRegister, typeCookieNewId, typeCookiePage, typeCookiePageId } from 'fixedData';

import Cookies from 'universal-cookie';

const cookies = new Cookies();

let ListPag = {
    "page"          : 'login',
    "idioma"        : 'pt_br',
    "currentPage"   : 'index',
    "currentPageId" : ''
};

let NotifyListPag = {
    "page"          : [],
    "idioma"        : [],
    "currentPage"   : [],
    "currentPageId" : []
}

export function SetListPag(key, value){
    ListPag[key] = value;
    NotifyListPag[key].forEach(element => {
        element(value);
    });

    if(key == 'currentPageId'){
        if(value == 'remuve'){
            cookies.remove(typeCookiePageId, '', '/', cookiesRegister);
            cookies.remove(typeCookieNewId, '', '/', cookiesRegister);
        }else {
            cookies.set(typeCookiePageId, value, '/', cookiesRegister);
        }
    }

    if(key == 'currentPage'){
        cookies.set(typeCookiePage, value, '/', cookiesRegister);
        cookies.remove(typeCookieNewId, '', '/', cookiesRegister);
    }
}

export function GetListPag(key){
    return ListPag[key];
}

export function RegisterListPag(key, value){
    if(!NotifyListPag[key]){
        NotifyListPag[key] = [];
    }
    NotifyListPag[key].push(value);
}
